import { useEffect } from 'react';
import { useColumnContextAPI } from '../../../shared/context/GetAllColumnContext';
import GridTable from '../../../shared/components/grid/GridTable';

export default function MultiHtzGrid({ tableRes, selectedHTZValue }) {
  const customSorting = {
    sortModel: [],
  };

  const { updateCustomConfig } = useColumnContextAPI();

  useEffect(() => {
    if (selectedHTZValue?.length) {
      const htzList = selectedHTZValue.reduce((resp, item) => {
        if (resp != '') {
          resp += ',';
        }
        resp += `"${item}"`;
        return resp;
      }, '');

      updateCustomConfig({
        AdditionalFilterQuery: `htz:{_in:[${htzList}]}`,
        ScreenSlotProps: {
          customSorting,
        },
        InitialGridFilterModel: {
          items: [
            {
              field: 'npi_htz',
              operator: 'isAnyOf',
              value: selectedHTZValue,
            },
          ],
          logicOperator: 'and',
        },
      });
    }
  }, [selectedHTZValue]);

  return (
    <>
      <GridTable tableRes={tableRes} />
    </>
  );
}
